import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import { route } from 'preact-router';
import Markdown from 'preact-markdown';
import md5 from 'crypto-js/md5';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';
import { isInactive as isVisitorInactive, sortInactiveLast } from '../../lib/visitorInactive';

import ViewFields from '../../components/form/viewFields';
import Input from '../../components/form/input';
import DyrejournalSaleSearch from '../../components/dyrejournal/search';
import { animalAge } from '../../lib/animalAge';


@withText(props => ({
    visitorTitle: <Text id='dyrejournal.visitor.search-title'>Search for visitor</Text>,
}))
@observer
class SearchVisitor extends Component {
	constructor(props) {
        super(props);
        this.state = {
            visitorAnimals: [],
        };
    }

    loadAnimals = async visitorIds => {
        const { animalStore, saleStore } = this.props.stores;
        if (visitorIds.length > 0) {
            const response = await animalStore.load({
                query: {
                    owner: visitorIds,
                },
                skipUpdate: true,
            });
            this.setState({ visitorAnimals: response });
        } else {
            this.setState({ visitorAnimals: [] });
        }
    }

    searchVisitorCallback = (visitor) => {
        console.log('searchVisitorCallback', visitor);
        if (visitor && visitor.id) {
            this.loadAnimals([visitor.id]);
            // Attach the customer to the event right away, so the booking is
            // still identifiable if the user never clicks one of the animals.
            const { calendarEventStore } = this.props.stores;
            calendarEventStore.updateObjectKeyValue('newCalendarEvent', 'visitors', [{
                md5: md5(JSON.stringify(visitor)).toString(),
                id: visitor.id,
                firstname: visitor.firstname,
                lastname: visitor.lastname,
                cellphone: visitor.cellphone,
                email: visitor.email,
            }]);
            const { newCalendarEvent } = calendarEventStore;
            if (!newCalendarEvent.animals || newCalendarEvent.animals.length === 0) {
                calendarEventStore.updateObjectKeyValue('newCalendarEvent', 'title', localUtil.showName(visitor));
            }
        }
    }

    onClickChooseAnimal = e => {
        const { idx, id, name } = e.target.closest('.resultLine').dataset;
        const { visitorAnimals } = this.state;

        // const animal = visitorAnimals[idx];
        // console.log('onClickChooseAnimal', { idx, id, name });

        const idInt = parseInt(id);
        const animal = visitorAnimals.find(e => e.id === idInt);
        // console.log('onClickChooseAnimal', animal);

        const { calendarEventStore } = this.props.stores;
        // const { newCalendarEvent } = calendarEventStore;
        // const { animals } = newCalendarEvent;
        calendarEventStore.updateObjectKeyValue('newCalendarEvent', 'animals', [{
            id: animal.id,
            name: animal.name,
            breed: animal.breed,
            species: animal.species,
            birth: animal.birth,
            chipId: animal.chipId,
        }]);
        calendarEventStore.updateObjectKeyValue('newCalendarEvent', 'title', `${animal.name} (${animal.species})`);
    }

    render() {
        const { visitorTitle } = this.props;
        const { visitorStore } = this.props.stores;
        const { visitorAnimals } = this.state;

        return(<>
            <div class=''>
                <DyrejournalSaleSearch
                    stores={this.props.stores}
                    key={'visitor'}
                    title={visitorTitle}
                    holdingStore={visitorStore}
                    searchResultList={'visitorResults'}
                    filterResults={sortInactiveLast}
                    searchResultsLine={(e, idx, selectedIndex) => {
                        const textColor = e.color ? (localUtil.isDark(e.color) ? 'text-light' : 'text-dark') : '';
                        return(<>
                            <div class={`d-flex flex-column px-3 py-1 ${idx === selectedIndex ? 'selected' : ''} ${isVisitorInactive(e) ? 'text-body-secondary' : ''}`}>
                                <div class='d-flex flex-row justify-content-between'>
                                    <div class={`${e.color ? 'rounded-pill px-2' : ''} ${textColor}`} style={`${e.color ? `background-color: ${e.color} !important;` : ''}`}>
                                        {localUtil.showName(e)}
                                        {isVisitorInactive(e) && <span class='badge bg-secondary ms-2'><Text id='input.visitor-isInactive'>Inactive</Text></span>}
                                    </div>
                                    <div class='ms-2'>{e?.cellphone}</div>
                                </div>
                                <div class='d-flex flex-row justify-content-between'>
                                    <small class='font-weight-lighter'>{e?.address} {e?.postalcode} {e?.place}</small>
                                </div>
                                {e.comment ? <>
                                    <div class='d-flex flex-row px-0 py-0 mt-1'>
                                        <small class='text-body-secondary'>
                                            <i class='fa-duotone fa-circle-info text-warning me-1' />{e.comment}
                                        </small>
                                    </div>
                                </> : null}
                            </div>
                        </>);
                    }}
                    callback={this.searchVisitorCallback}
                    skipSaleUpdate={true}
                    // rightButton={'hasVisitor && newSaleTItle'}
                    // rightButtonClassNames='btn-success'
                    // rightButtonClick={this.onClickNewSale}
                    ref={c => this.visitorSearchRef = c}
                />
            </div>
            <div>
                {(visitorAnimals && visitorAnimals.length > 0) && <>
                    <div class='mt-3'>
                        <div class='font-weight-lighter text-muted'>
                            <small class='text-uppercase'>
                                <Text id='dyrejournal.animal.owned-by-visitor'>Animals owned by visitor</Text>
                            </small>
                        </div>
                        <div class='d-flex flex-wrap overflow-auto' style='max-height: 200px;'>
                            {visitorAnimals.filter(e => !e.isDececed && !e.isRelocated && !e.isInactive).map((e, idx) => <>
                                <small
                                    class={`${e.isLost ? 'bg-danger text-white' : e.isDececed ? 'bg-warning' : e.isRelocated ? 'bg-info' : e.isInactive ? 'bg-secondary text-white' : 'bg-light'} resultLine d-flex justify-content-between me-2 mt-1 px-2 font-weight-normal rounded-lg`}
                                    style='cursor: pointer; width: 32%;'
                                    onClick={this.onClickChooseAnimal}
                                    data-idx={idx}
                                    data-id={e.id}
                                    data-name={e.name}
                                >
                                    {e.isLost && <i class='fa-duotone fa-magnifying-glass-location me-1' />}
                                    {e.isDececed && <i class='fa-duotone fa-tombstone me-1' />}
                                    {e.isRelocated && <i class='fa-duotone fa-arrow-up-right-from-square me-1' />}
                                    {e.isInactive && <i class='fa-duotone fa-ban me-1' />}
                                    <div class='flex-fill'>{e.name} ({e.species})</div>
                                    <div class='ms-2 text-end'><nobr>{e.chipId && <><i class='fa-solid fa-microchip text-muted me-2' /></>} {e.birth && animalAge(e.birth)}</nobr></div>

                                </small>
                            </>)}
                        </div>
                    </div>
                </>}
            </div>
        </>);
    }
}

export default SearchVisitor;